import { render } from "./SigninForm.vue?vue&type=template&id=327de2ca&scoped=true"
import script from "./SigninForm.vue?vue&type=script&lang=js"
export * from "./SigninForm.vue?vue&type=script&lang=js"

import "./SigninForm.vue?vue&type=style&index=0&id=327de2ca&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-327de2ca"

export default script